import type { CreateStyled, Theme } from '@sds-system/types';
import createStyled from './createStyled/createStyled';

export const styled = createStyled<Theme>() as CreateStyled<Theme>;
